import {Component, Input} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {SessionStorageService} from '../../services/session-storage.service';
import {ParentChildService} from '../../services/parent-child.service';
import {Subscription} from 'rxjs/Subscription';

/**
 *Interfaces*/
export interface BreadCrumb {
    label: string;
    icon: string;
    status: boolean;
    initialRoute?: string;
    outlets?: Object;
    url: string;
}

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent {
    @Input() separatorClass = '';
    breadcrumbs: Array<BreadCrumb>;
    tabList: any;
    subscription: Subscription;

    constructor(private router: Router, private route: ActivatedRoute, private sessionStorageService: SessionStorageService, private parentChildService: ParentChildService) {
        this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.tabList = this.sessionStorageService.getTabSession();
                this.breadcrumbs = [];
                let currentRoute = this.route.root,
                    url = '';
                do {
                    const childrenRoutes = currentRoute.children;
                    currentRoute = null;
                    /*childrenRoutes.forEach((routes: any) => {
                        const routeSnapshot = routes.snapshot;
                        url += '/' + routeSnapshot.url.map((segment: any) => segment.path).join('/');
                        if (routes.snapshot.data.breadcrumb !== undefined) {
                            let status = true;
                            if (routes.snapshot.data.status !== undefined) {
                                status = routes.snapshot.data.status;
                            }
                            const URL = url.replace('/', '').split('/');

                            this.breadcrumbs.push({
                                label: routes.snapshot.data.breadcrumb.toUpperCase(),
                                icon: routes.snapshot.data.icon,
                                status: status,
                                initialRoute: routes.outlet == 'primary' ? '/' + URL[URL.length - 2] : '/' + routes.outlet,
                                outlets: {outlets: {[routes.outlet]: URL[URL.length - 1]}}
                            });
                        }
                        currentRoute = routes;
                    });*/
                    childrenRoutes.forEach(routes => {
                        if (routes.outlet === 'primary') {
                            const routeSnapshot = routes.snapshot;
                            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
                            if (routes.snapshot.data.breadcrumb !== undefined) {
                                let status = true;
                                if (routes.snapshot.data.status !== undefined) {
                                    status = routes.snapshot.data.status;
                                }
                                this.breadcrumbs.push({
                                    label: routes.snapshot.data.breadcrumb.toUpperCase(),
                                    icon: routes.snapshot.data.icon,
                                    status: status,
                                    url: url
                                });
                            }
                            currentRoute = routes;
                        }
                    });
                } while (currentRoute);
            });
    }
}
